import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import bootstrap from 'bootstrap';
import Handlebars from 'handlebars';
import Global from 'models/Global';
import BootstrapData from 'models/BootstrapData';
import RenderedView from 'views/RenderedView';
import SectionRenderMixin from 'web-common/editor-templates/scripts/SectionRenderMixin';
import config from 'config';
import { renderReact } from 'utils/reactRoot';
import SectionFactory from '@bizzabo/website-sections';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { onCategoryAllowed, ConsentCategory } from 'utils/consentHelper';

var SectionView = RenderedView.extend({

    events: {

    },

    initialize: function(options) {
        this.subViews = [];
        this.findTemplate();
    },

    remove: function() {
        this.removeSubviews();
        return RenderedView.prototype.remove.call(this);
    },

    removeSubviews: function() {
        _.each(this.subViews, function(subView) {
            subView.remove();
        });
        this.subViews = [];
    },

    findTemplate: function() {
        const { template = '' } = BootstrapData('bootstrap-data-siteConf') || {};
        this.template = Handlebars.sectionsTemplates[this.model.get('template') + '/' + this.model.get('type')];
        if (!this.template) {
            this.template = Handlebars.sectionsTemplates['common' + '/' + this.model.get('type')] || Handlebars.sectionsTemplates[template + '/' + this.model.get('type')];
        }
    },

    shouldReturnReactSection: function(type) {
        const reactSectionExists = SectionFactory.isExist(type);
        return reactSectionExists;
    },

    render: function() {
        let event = Global.get('event');
        event = event ? event.toJSON() : {};
        const section = this.model.toJSON();
        const type = section.type;
        const isReactSection = this.shouldReturnReactSection(type);
        const registrationProxyEnabled = FeatureToggleUtils.isFeatureEnabled('authReg', 'feature-sso-enable-attendee-sso') || FeatureToggleUtils.isFeatureEnabled('regProxy');
        const flowId = type === 'tickets' ? section?.elements?.find(element => element.type === 'tickets')?.flowId : null;
        // Important: Please check enrichReactSections() on HomeService in the node.js backend to ensure you pass all desired args.
        if (isReactSection){
            const bypassCookieConsent = FeatureToggleUtils.isFeatureEnabled('bypass-cookie-consent');
            const onMapsAllowed = bypassCookieConsent ? undefined : (callback) => onCategoryAllowed(ConsentCategory.Targeting, callback);
            const configParams = {...config, FeatureToggleUtils, global: Global.toJSON(), onMapsAllowed};
            const sectionData = {...section, event, registrationProxyEnabled, flowId};
            const SectionComponent = SectionFactory.create(section.type, sectionData, configParams);
            renderReact(this.el, SectionComponent);

        } else {
            RenderedView.prototype.render.call(this, this.template);
        }

        return this;
    },

    postRender: function() {
        var templateClass = this.model.get('template') + '-template';
        if (!this.$el.hasClass(templateClass)) {
            var wrapperDiv = '<div class="' + this.model.get('template') + '-template section-' + this.model.get('rootKey') + '">' + this.$el.html() + '</div>';
            this.$el.html(wrapperDiv);
        }
        this.removeSubviews();
        this.renderByType();
        return this;
    },

    renderByType: function() {
        var thisView = this;
        var type = this.model.get('type');
        _.each(this.model.get('elements'), function(element) {
            var functionName = thisView.elementsRender[element.type];
            functionName && thisView[functionName](element);
        });
        return this;
    }
});

_.extend(SectionView.prototype, SectionRenderMixin);

export default SectionView;


